import { render } from "./Profile.vue?vue&type=template&id=bda4ff80"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=bda4ff80&lang=scss"

import exportComponent from "/home/nboq9356/fdes-meiser.ailoop.io/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__